<div class="step-two-col">
  <div class="step-col-main">
    <first-meeting-template></first-meeting-template>
    <date-setted></date-setted>
  </div>
  <div class="step-col-report">
    <report></report>
  </div>
</div>